import { PropTypes } from 'prop-types';
import { Alert } from 'antd';
import { useIntl } from 'react-intl';
import React from 'react';
import loader from '../../style/img/ajax-loader.svg';

const Spinner = ({ loading, style, showUploadDelayInfo }) => {
  const { formatMessage } = useIntl();
  return (
    <div
      style={{ minHeight: '100vh', position: 'fixed', ...style }}
      id="spinner"
      className="spinner"
      hidden={!loading}
    >
      <img src={loader} height="64" width="64" alt="Loading"></img>
      {showUploadDelayInfo && (
        <Alert
          message={formatMessage({ id: 'uploadFile.info.title' })}
          description={formatMessage({ id: 'uploadFile.info.description' })}
          type="warning"
          style={{
            position: 'absolute',
            top: '43%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      )}
    </div>
  );
};

Spinner.propTypes = {
  loading: PropTypes.bool,
  style: PropTypes.shape({}),
  showUploadDelayInfo: PropTypes.bool,
};

Spinner.defaultProps = {
  loading: false,
  style: {},
  showUploadDelayInfo: false,
};

export default Spinner;
